import { useEffect, useState } from 'react';
import { toastManager, Toast } from '../../utils/notifications';
import { Alert } from './Alert';

export const ToastContainer: React.FC = () => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const unsubscribe = toastManager.subscribe(setToasts);
    return unsubscribe;
  }, []);

  const topRightToasts = toasts.filter((t) => (t.position ?? 'top-right') === 'top-right');
  const centerToasts = toasts.filter((t) => t.position === 'center');

  return (
    <>
      {topRightToasts.length > 0 && (
        <div className="fixed top-4 right-4 z-50 space-y-2 w-full max-w-sm dark:bg-gray-900/95 dark:border dark:border-gray-700 dark:rounded-lg dark:p-2">
          {topRightToasts.map((toast) => (
            <Alert
              key={toast.id}
              variant={toast.type}
              onClose={() => toastManager.remove(toast.id)}
              className="animate-slide-up"
            >
              {toast.message}
            </Alert>
          ))}
        </div>
      )}
      {centerToasts.length > 0 && (
        <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
          <div className="pointer-events-auto">
            {centerToasts.map((toast) => (
              <Alert
                key={toast.id}
                variant={toast.type}
                onClose={() => toastManager.remove(toast.id)}
                className="animate-slide-up shadow-xl max-w-sm"
              >
                {toast.message}
              </Alert>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

